import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "video-wall-preset-select" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VideoWallPresetSelectItem = _resolveComponent("VideoWallPresetSelectItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presets, (preset) => {
      return (_openBlock(), _createBlock(_component_VideoWallPresetSelectItem, {
        key: preset.id,
        preset: preset,
        onClick: ($event: any) => (_ctx.dispatchSelectEvent(preset)),
        onDelete: ($event: any) => (_ctx.dispatchDeleteEvent(preset))
      }, null, 8, ["preset", "onClick", "onDelete"]))
    }), 128))
  ]))
}